import React, { useEffect } from "react";

import Payouts from "./Payouts";
import OwnliScreenWrapper from "../ownli/OwnliScreenWrapper";
import RewardsSummary from "./RewardsSummary";
import track from "../../lib/analytics/events";

const OMIGReward = ({ customer: propCustomer }) => {
  useEffect(() => {
    track.rewardsViewed();
  }, []);

  return (
    <OwnliScreenWrapper>
      <div className="max-w-3xl mx-auto space-y-6">
        <RewardsSummary />
        <Payouts />
      </div>
    </OwnliScreenWrapper>
  );
};

export default OMIGReward;
